






















import { defineComponent, ref, toRefs, watch } from '@vue/composition-api'
import getClosestWord from '../../utils/getClosestWord'
import { removePunctuation } from '../../utils/removePunctuation'
import { useTemporaryLock } from '../../components/editor/useTemporaryLock'
import { useCursorMover } from '../../components/editor/useCursorMover'

const SAVE_LOCK_TIMEOUT = 30

export default defineComponent({
  name: 'PartField',
  emits: ['word-click'],
  props: {
    text: {
      type: String,
      required: true
    },
    textareaId: {
      type: String
    }
  },
  setup(props, { emit }) {
    const { text } = toRefs(props)
    const currentText = ref('')
    const { lock, unlock, isLocked } = useTemporaryLock(SAVE_LOCK_TIMEOUT)
    const {
      textareaTrackingClass,
      handleArrowLeft,
      handleArrowRight
    } = useCursorMover()

    watch(text, () => (currentText.value = text.value), { immediate: true })

    function handleClick({ target }) {
      const offset = target.selectionStart

      //We want to ignore selection, only handle click
      if (offset !== target.selectionEnd) {
        return
      }

      const rawWord = getClosestWord(currentText.value, offset)
      const word = removePunctuation(rawWord)
        .toLowerCase()
        .trim()

      if (word) {
        emit('word-click', { word, offset })
      }
    }

    function handleEnter({ target: { selectionStart } }) {
      emit('enter-pressed', {
        offset: selectionStart,
        text: currentText.value
      })
    }

    function handleDelete({ target: { selectionStart, selectionEnd, value } }) {
      if (selectionStart !== value.length || selectionStart !== selectionEnd) {
        return //We want trigger only at the end of text and it is not a selection
      }

      //We are skipping next blur event as we don't want to save part that is already deleted
      lock()
      emit('delete-at-end', {
        text: currentText.value
      })
    }

    function handleBackspace({ target: { selectionStart, selectionEnd } }) {
      if (selectionStart !== 0 || selectionStart !== selectionEnd) {
        return //We want trigger only at the start of text and it is not a selection
      }

      //We are skipping next blur event as we don't want to save part that is already deleted
      lock()
      emit('backspace-at-start', {
        text: currentText.value
      })
    }

    function handleBackspaceOrDelete(event) {
      switch (event.key) {
        case 'Backspace':
          return handleBackspace(event)
        case 'Delete':
          return handleDelete(event)
      }
    }

    function handleBlur() {
      if (isLocked.value) {
        unlock()
        return
      }

      emit('blur', currentText.value)
    }

    return {
      currentText,
      handleClick,
      handleEnter,
      handleBackspaceOrDelete,
      handleBlur,
      handleArrowLeft,
      handleArrowRight,
      textareaTrackingClass
    }
  }
})
